import type { FC } from "react";

import ContainerComponent from "@/components/global/ContainerComponent/ContainerComponent";
import { cn } from "@/utils/common/styleHelper/utils";

import SkeletonPromotionButtonTypeComponent from "./SkeletonPromotionButtonTypeComponent";
import SkeletonPromotionCarouselComponent from "./SkeletonPromotionCarouselComponent";
import SkeletonPromotionHeadingComponent from "./SkeletonPromotionHeadingComponent";

interface SkeletonPromotionSlideProps {
  isHomePage?: boolean;
  isShowIcon?: boolean;
  showTitleSkeleton?: boolean;
}

const SkeletonPromotionSlideComponent: FC<SkeletonPromotionSlideProps> = ({
  isHomePage = false,
  isShowIcon = false,
  showTitleSkeleton = false,
}) => {
  return (
    <ContainerComponent
      className={cn(
        "gap-y-4 py-6 md:gap-y-6 xl:py-10 pl-4 md:pl-0",
        isHomePage ? "min-h-[20.188rem]" : "",
      )}
    >
      {showTitleSkeleton && (
        <SkeletonPromotionHeadingComponent isShowIcon={isShowIcon} />
      )}
      {isHomePage && (
        <>
          <SkeletonPromotionHeadingComponent />
          <SkeletonPromotionButtonTypeComponent />
        </>
      )}
      <SkeletonPromotionCarouselComponent />
    </ContainerComponent>
  );
};

export default SkeletonPromotionSlideComponent;
